<template>
  <ion-item lines="full" :router-link="{
      name: 'PostDetailPage',
      params: { id: post.id, ...extraRouterParams }
    }" button detail>
    <ion-thumbnail v-if="!isPostAuthorBanned(post) && post.image" slot="start">
      <img :src="post.image">
    </ion-thumbnail>
    <ion-label>
      <h3 v-if="!isPostAuthorBanned(post)">
        {{ post.title }}
        <small v-if="post.likeCount >= post.dislikeCount"><ion-icon :icon="thumbsUpOutline"></ion-icon> {{ post.likeCount - post.dislikeCount }}</small>
        <small v-else><ion-icon :icon="thumbsDownOutline"></ion-icon> {{ post.dislikeCount - post.likeCount }}</small>
        {{ post.rating }}
      </h3>
      <p v-if="!isPostAuthorBanned(post)">{{ post.content }}</p>
      <p v-if="isPostAuthorBanned(post)">{{ t('PostPage.blockedContent') }}</p>
      <p><small>{{ formatDate(post.createdAt) }}</small></p>
      <ion-chip class="user-chip">
        <ion-avatar>
          <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" />
        </ion-avatar>
        <ion-label>{{ post.username || 'Unknown' }}</ion-label>
      </ion-chip>
    </ion-label>
  </ion-item>
</template>


<script lang="ts">
// icons
import { thumbsUpOutline, thumbsDownOutline, ban, } from 'ionicons/icons';

// components
import { IonItem, IonLabel, IonChip, IonIcon, IonThumbnail, IonAvatar, } from '@ionic/vue';

import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';

export default {
  props: [
    "post",
    "hideUserChip",
    "extraRouterParams",
  ],
  components: { IonItem, IonLabel, IonChip, IonIcon, IonThumbnail, IonAvatar, },
  setup() {
    const { t } = useI18n();
    const { formatDate, isPostAuthorBanned } = utils();

    // 3. return variables & methods to be used in template HTML
    return {
      t,

      // icons
      thumbsUpOutline, thumbsDownOutline, ban,

      // methods
      formatDate, isPostAuthorBanned,
    }
  }
}
</script>

<style scoped>
  .user-chip {
    font-size: 12px;
    margin-left: 0;
  }
</style>